module.exports = __webpack_public_path__ + "img/logo+sologen.0500ad68.png";